import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './idb-image-banner-cta.css.lit';
import { SlotController } from '../../controllers/slot-controller';
import { classMap } from 'lit/directives/class-map.js';

/**
 * The CTA Banner component.
 * @element idb-image-banner-cta
 * @property center heading - centers the heading and makes it smaller
 * @slot background - Background image
 * @slot heading - Heading
 * @slot paragraph - The descriptive paragraph
 * @slot cta - Call to actions
 * @todo maybe make it based on percentages instead of a grid
 * @todo fix the heading spacing that also affects the sliders etc. (gets too small on mobile)
 */

@customElement('idb-image-banner-cta')
export class ImageBannerCTA extends OutlineElement {
  slots = new SlotController(
    this, // This, the host element.
    true // To shift or not to shift LightDom nodes to ShadowDOM.
  );

  static styles: CSSResultGroup = [componentStyles];

  @property({ type: Boolean, reflect: true, attribute: 'centered' })
  centered = false;

  @property({ type: Boolean, reflect: true, attribute: 'left-aligned' })
  leftAligned = false;

  @property({ type: Boolean, reflect: true, attribute: 'new-design' })
  newDesign = false;

  @property({ type: Boolean, reflect: true, attribute: 'wide-title' })
  wideTitle = false;

  render(): TemplateResult {
    return html`
        <div class="${classMap({
          'link': true,
          'new-design': this.newDesign,
        })}">
          ${this.grayOverlay()}
          <slot name="background"></slot>
          <div class="${classMap({
            'text-wrapper': true,
            'centered': this.centered,
            'left-aligned': this.leftAligned,
            'wide-title': this.wideTitle,
            'new-design': this.newDesign,
          })}">
              <div class="${classMap({
                'banner-heading': true,
                'wide-title': this.wideTitle,
              })}">
                  <slot name="heading"></slot>
              </div>
              ${
                this.querySelector('[slot="paragraph"]') !== null
                  ? html`
                  <div class="paragraph">
                    <slot name="paragraph"></slot>
                  </div>
                `
                  : ''
              }
              <div class="cta">
                  <slot name="cta"></slot>
              </div>
            </div>
        </div>
    `;
  }

  grayOverlay(): TemplateResult | null {
    if (!this.newDesign) {
      return html`<div></div>`;
    } else {
      return null;
    }
  }
}
